import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { BooleanSettingsControlInterface } from 'modules/settingsContainer/common/BooleanSettings/types';

type ShowValueSettingsProps = Required<BooleanSettingsControlInterface>;

export const ShowValueSettings = ({ value, onChange }: ShowValueSettingsProps) => {
  return <BooleanSettings titleText="Показать значения" value={value} onChange={onChange} />;
};
